import React, { useState } from 'react'
import { Typography, Card, Grid, Button } from "@mui/material";
import GuestManagementTable from '../../../components/admin/userManagement/guest';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import CreationDialog from '../../../components/dialog';
import GuestCreation from '../../../components/admin/userManagement/guest/guestCreation';

const GuestManagementTemp = () => {

    const [open, setOpen] = useState(false)

    return (
        <>
            <Card style={{ boxShadow: (theme)=> `0px 12px 23px ${theme.palette.grey[200]}` }}>
                <Grid container spacing={3} sx={{ padding: '30px', pb: '20px' }} >
                    <Grid item lg={6} xs={6} sx={{ justifyContent: 'left' }}>
                        <div>
                            <Typography variant='t20_600'>Guest Management </Typography>
                        </div>
                    </Grid>
                    <Grid item xs={6} sx={{ justifyContent: 'right', display: 'flex' }}>
                        <Button variant='contained' endIcon={<DoubleArrowIcon />} sx={{ width: '197px', height: '50px' }} onClick={() => setOpen(true)} >
                        <Typography variant='t16_500' >
                            Add Guest
                            </Typography>
                        </Button>
                    </Grid>
                    <Grid item xs={12}>
                        <GuestManagementTable />
                    </Grid>
                </Grid>
            </Card>
            <CreationDialog open={open} setOpen={setOpen} >
                <GuestCreation setOpen={setOpen} />
            </CreationDialog >
        </>
    )
}

export default GuestManagementTemp;